/**
 * localStorage key for 21+ attestation. Bump the suffix (e.g. `_v3`) when you need every
 * visitor to see the age gate again after a policy or UX change.
 */
export const STORAGE_KEY = "jmanatx_21plus_ok_v2";
